import type { Dayjs } from "dayjs";
import dayjs from "dayjs";

import type { Translate } from "pro-features/components/WithTranslation";

type PresetConfig = {
    id: string;
    count: string;
    unitKey: "day.nomerous" | "month.single" | "month.nomerous";
    subtract: { value: number; unit: "day" | "month" };
    isDaily: boolean;
    displayTextSuffix?: string;
    customDateRange?: { from: Dayjs; to: Dayjs };
};

const createPreset = (translate: Translate, config: PresetConfig) => {
    const text = translate("datepicker.lastn", {
        count: config.count,
        unit: translate(`datepicker.units.${config.unitKey}`),
    });

    const today = dayjs();
    const fromDate = config.customDateRange?.from ?? today.subtract(config.subtract.value, config.subtract.unit);
    const toDate = config.customDateRange?.to ?? today;

    return {
        id: config.id,
        text,
        displayText: config.displayTextSuffix ? `${text} ${config.displayTextSuffix}` : text,
        value: {
            from: config.isDaily ? fromDate.startOf("day") : fromDate,
            to: config.isDaily ? toDate.endOf("day") : toDate,
            isDaily: config.isDaily,
        },
        title: "duration.title",
        tooltipContent: "",
    };
};

type DefaultPresetsParams = {
    translate: Translate;
    windowStartDate: Dayjs;
    windowEndDate: Dayjs;
};

export const getDefaultPresets = ({ translate, windowStartDate, windowEndDate }: DefaultPresetsParams) => [
    createPreset(translate, {
        id: "28d",
        count: "28",
        unitKey: "day.nomerous",
        subtract: { value: 28, unit: "day" },
        isDaily: false,
        displayTextSuffix: `(As of ${windowEndDate.format("MMM D")})`,
        customDateRange: { from: windowStartDate, to: windowEndDate },
    }),
    createPreset(translate, {
        id: "1m",
        count: "1",
        unitKey: "month.single",
        subtract: { value: 1, unit: "month" },
        isDaily: false,
    }),
    createPreset(translate, {
        id: "3m",
        count: "3",
        unitKey: "month.nomerous",
        subtract: { value: 3, unit: "month" },
        isDaily: false,
    }),
    createPreset(translate, {
        id: "6m",
        count: "6",
        unitKey: "month.nomerous",
        subtract: { value: 6, unit: "month" },
        isDaily: false,
    }),
];

export const getAdsPagePresets = (translate: Translate) => [
    createPreset(translate, {
        id: "7d",
        count: "7",
        unitKey: "day.nomerous",
        subtract: { value: 7, unit: "day" },
        isDaily: true,
    }),
    createPreset(translate, {
        id: "14d",
        count: "14",
        unitKey: "day.nomerous",
        subtract: { value: 14, unit: "day" },
        isDaily: true,
    }),
    createPreset(translate, {
        id: "28d",
        count: "28",
        unitKey: "day.nomerous",
        subtract: { value: 28, unit: "day" },
        isDaily: true,
    }),
];
